import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "platform-logs-pagination mt-6" }
const _hoisted_2 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row items-center justify-between gap-4" }
const _hoisted_4 = { class: "text-sm text-gray-600" }
const _hoisted_5 = { class: "font-semibold text-gray-800" }
const _hoisted_6 = { class: "font-semibold text-gray-800" }
const _hoisted_7 = { class: "font-semibold text-blue-600" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createTextVNode(" نمایش ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.startItem), 1),
          _cache[3] || (_cache[3] = _createTextVNode(" تا ", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.endItem), 1),
          _cache[4] || (_cache[4] = _createTextVNode(" از ", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.totalItems), 1),
          _cache[5] || (_cache[5] = _createTextVNode(" مورد ", -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_pagination, {
            modelValue: _ctx.currentPage,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
              _ctx.onPageChange
            ],
            length: _ctx.totalPages,
            "total-visible": 7,
            circle: "",
            class: "compact-pagination"
          }, null, 8, ["modelValue", "length", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm text-gray-600 whitespace-nowrap" }, "تعداد در صفحه:", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.currentPageSize,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPageSize) = $event)),
              _ctx.onPageSizeChange
            ],
            items: _ctx.pageSizeOptions,
            dense: "",
            outlined: "",
            "hide-details": "",
            class: "compact-select",
            style: {"max-width":"80px"}
          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
        ])
      ])
    ])
  ]))
}